import { createRoutine } from 'redux-saga-routines';

export const fetchReportForOutreachAggregate = createRoutine(
  'FETCH_REPORT_FOR_OUTREACH_AGGREGATE'
);

export const fetchOutreachAggregateOptions = createRoutine(
  'FETCH_OUTREACH_AGGREGATE_OPTIONS'
);
